<template>
  <MenuItem
    v-if="list"
    class="h11-links"
    data-qa="item-toggleTemplate"
    :icon="icon"
    :label="text"
    @click.stop="$emit('click')"/>
  <sButton
    v-else
    class="px-2"
    color="var(--white-color)"
    data-qa="btn-toggleTemplate"
    :icon="icon"
    type="text"
    @click.stop="$emit('click')">
    {{ text }}
  </sButton>
</template>

<script>
import MenuItem from 'components/common/MenuItem.vue'

export default {
  name: 'toggleTemplates',
  props: {
    add: Boolean,
    list: Boolean
  },
  computed: {
    icon() {
      return this.add ? 'file-add' : 'file-minus'
    },
    text() {
      return this.add ? this.$t('Common.SaveAsTemplate') : this.$t('Common.DeleteFromTemplate')
    }
  },
  components: {
    MenuItem
  }
}
</script>
